module.exports = __webpack_public_path__ + "img/bannerLabel3Green.56d2d18b.png";